<script>
    // Hack to make sure the header is gone. Needs a timeout or it breaks everything.
    setTimeout(function () {
        document.getElementById("header").setAttribute("style", "display: none;")
    }, 1);
</script>

<style>
    .center {
        display: block;
        margin: auto auto 100px auto;
        width: 500px;
        text-align: center;
        font-size: 50px;
    }

    .foot {
        position: absolute;
        bottom: 0;
        left: 0;
    }
</style>

<div class="center">
    <span>Are you lost?</span>
    <img alt="corona 404" class="corona" src="images/404-corona.png"/>
    <span>We couldn't find that page.</span>
</div>

<div class="foot">
    <section>
        <a href="#/">Terug</a> naar het bestelformulier.
    </section>
</div>
